'use strict'

export const SPACING = {
  ratio: 1.618,
  subSequence: true
}
